module.exports = __webpack_public_path__ + "static/img/logo.be3c0ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = zxL1
// module chunks = 0